module.exports = __webpack_public_path__ + "static/media/Standby.281ff547.svg";